import { render, staticRenderFns } from "./numberTips.vue?vue&type=template&id=0814043b&scoped=true"
import script from "./numberTips.vue?vue&type=script&lang=js"
export * from "./numberTips.vue?vue&type=script&lang=js"
import style0 from "./numberTips.vue?vue&type=style&index=0&id=0814043b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0814043b",
  null
  
)

export default component.exports